import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

import styles from './Badge.module.css';

export type BadgeTone = 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps {
  tone?: BadgeTone;
  /** A leading dot — status badges use it so colour is never the only signal. */
  dot?: boolean;
  children: ReactNode;
  className?: string | undefined;
}

/** Status always pairs a colour with a word. */
export function Badge({ tone = 'neutral', dot = false, children, className }: BadgeProps) {
  return (
    <span className={cn(styles.badge, styles[tone], className)}>
      {dot && <span className={styles.dot} aria-hidden="true" />}
      {children}
    </span>
  );
}
